import { __assign, __rest } from "tslib";
import React from 'react';
import ReactMarkdown from 'react-markdown';
export var MarkdownViewer = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    return React.createElement(ReactMarkdown, __assign({}, rest), children);
};
//# sourceMappingURL=MarkdownViewer.js.map